import {
  findTextIdForCardBackground,
  getGroupMemberIds,
  getTextBackgroundCardTextId,
  isTextBackgroundCardGroup,
  TEMPLATE_CARD_BACKGROUND_KEY,
} from '../utils/annotationGroupUtils';

export const SELECT_ANNOTATION = 'SELECT_ANNOTATION';

const resolveSingleClickSelectionIds = (state, annotationId) => {
  const clicked = state.annotations[annotationId];

  if (clicked?.[TEMPLATE_CARD_BACKGROUND_KEY]) {
    const textId =
      (clicked.groupId &&
        isTextBackgroundCardGroup(state.annotations, clicked.groupId) &&
        getTextBackgroundCardTextId(state.annotations, clicked.groupId)) ||
      findTextIdForCardBackground(state.annotations, annotationId);
    return textId ? [textId] : [annotationId];
  }

  if (
    clicked?.groupId &&
    isTextBackgroundCardGroup(state.annotations, clicked.groupId)
  ) {
    const textId = getTextBackgroundCardTextId(
      state.annotations,
      clicked.groupId,
    );
    return textId ? [textId] : [annotationId];
  }

  if (clicked?.groupId) {
    return getGroupMemberIds(state.annotations, annotationId);
  }

  return [annotationId];
};

const selectAnnotation = (state, payload) => {
  const { annotationId, multiple } = payload;
  const { selectionsIds = [] } = state;
  const isAlreadySelected = selectionsIds.includes(annotationId);

  if (selectionsIds.length === 1 && selectionsIds[0] === annotationId && !multiple) {
    return state;
  }

  if (multiple) {
    if (isAlreadySelected) {
      return {
        ...state,
        selectionsIds: selectionsIds.filter((id) => id !== annotationId),
      };
    }

    return {
      ...state,
      selectionsIds: [...selectionsIds, annotationId],
    };
  }

  if (selectionsIds.length > 1 && isAlreadySelected) {
    const nextSelectionsIds = selectionsIds.filter((id) => id !== annotationId);
    return {
      ...state,
      selectionsIds: nextSelectionsIds,
    };
  }

  return {
    ...state,
    selectionsIds: resolveSingleClickSelectionIds(state, annotationId),
  };
};

export default selectAnnotation;
